<template lang="pug">
  div
    section.content-header
      h1 お知らせの詳細

      ol.breadcrumb
        li
          router-link(:to="{name: 'top'}")
            span.glyphicon.glyphicon-home
            | TOP
        li
          router-link(:to="{name: 'information'}") お知らせ
        li.active お知らせの詳細

    section.content

      mixin btnbar
        .row.bcard-btnbar(class!=attributes.class)
          .col-sm-4
            router-link.btn.btn-default(:to="{name: 'information'}" title="戻る"): i.fa.fa-reply
            |
            |
            .btn-separator
            |
            |
            button.btn.btn-danger(type="button" @click="modalState = true" :disabled="isLoading") 削除

      +btnbar
      app-messages(:errorMessages="errors", :successMessages="successes")
      .box.bcard-info-detail(:class="getBoxClassName(info.type)")
        .box-header.with-border
          .pull-right {{info.lang_function}}
          .box-title
            info-icon(:functionCode="info.function", :infoType="info.type" showMode="list")
            |
            |
            | {{info.message}}

        .box-body
          p.text-prewrap {{info.msgdetail}}
          router-link(v-if="info.sid_data", :to="linkToTarget") 該当の画面を表示する

        .box-footer.text-right
          span.text-muted {{info.updated}}

      +btnbar.-bottom

    portal(to="modal")
      //- お知らせの削除
      app-modal(v-model="modalState" type="danger")
        template(slot="title") お知らせの削除
        h4 お知らせを削除します。よろしいですか？
        template(slot="footer" slot-scope="{close}")
          button.btn.btn-danger(@click.prevent="delData") 削除
          button.btn.btn-default(@click.prevent="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import InfoIcon from '@/components/molecules/InfoIcon'
import mixinInfo from '@/mixins/info'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const InfoRepository = RepositoryFactory.get('info')
const BcardRepository = RepositoryFactory.get('bcard')

export default {
  name: 'InformationDetail',
  components: { AppModal, AppMessages, InfoIcon },
  mixins: [ mixinInfo ],
  props: {
    id: {
      type: [String, Number],
      required: false,
      default: 0
    },
    item: {
      type: Object,
      required: false,
      default () {
        return {
          type: '',
          function: '...',
          message: '...',
          msgdetail: '...',
          lang_function: '...',
          updated: '...'
        }
      }
    }
  },
  data () {
    return {
      info: {},
      modalState: false,
      isLoading: true,
      sidPerson: 0
    }
  },
  computed: {
    /**
     * 該当の画面を表示する
     * @param String type お知らせ種別
     * @param String func 機能番号
     * @param Integer sid_data 対象データID
     */
    linkToTarget () {
      const type = this.info.type
      const func = this.info.function
      const sid_data = this.info.sid_data
      if (!type || !func || !sid_data) {
        return '#'
      }

      // お知らせ種別 = TODO かつ 機能番号 = 同一人物判定 の場合
      // 同一人物判定（同一人物判定をしてください）（sid_data＝人物ID）
      if (type === this.info_type.TODO && func === this.info_function.DUPLICATED) {
        // return {name: 'merge-persons-list-edit', params: {id: '' + sid_data, isJudge: true}}
        return {name: 'merge-persons-detail', params: {id: sid_data}}
      }
      // 修正サービス読み取りエラーの場合（sid_data＝名刺ID）
      // BT0050360 戻るパスをお知らせ一覧にする → お知らせ詳細に戻るように変更
      else if (func === this.info_function.DAIKO) {
        return {name: 'box-history-detail', params: {sidPerson: this.sidPerson, sidBcard: sid_data}}
      }
      // 機能番号 = 同一人物判定 の場合（同一人物判定により個人的なメモが統合されました）（sid_data＝人物ID）
      else if (func === this.info_function.DUPLICATED) {
        return {name: 'box-detail', params: {sidPerson: sid_data}}
      }
      // 名刺が統合されましたor名刺交換者に指定されました（sid_data＝名刺ID）
      else if (func === this.info_function.BCUPDATE) {
        return {name: 'box-detail', params: {sidPerson: this.sidPerson}}
      }
      // 最新名刺入れ替えの場合（sid_data＝人物ID）
      else if (func === this.info_function.NEWBCCHANGED) {
        return {name: 'box-detail', params: {sidPerson: sid_data}}
      }
      // その他（sid_data＝名刺ID）
      else {
        return {name: 'box-history-detail', params: {sidPerson: this.sidPerson, sidBcard: sid_data}}
      }
    }
  },
  created () {
    // API実行前の初期データ
    this.info.type = this.item.type
    this.info.function = this.item.function
    this.info.message = this.item.message
    this.info.msgdetail = '...'
    this.info.lang_function = this.item.lang_function
    this.info.updated = this.item.updated

    // 変更時の初期データ
    if (this.id) {
      // API実行
      const vm = this
      // idが12文字丁度しか受け付けないので、12文字ではない場合でもパスのidが12文字になるようにする
      InfoRepository.get(this.id)
        .then(function (response) {
          const infoMsg = vm.getApiData(response).data
          vm.info = infoMsg

          // 取得したお知らせが未読 かつ TODO以外の場合
          if (vm.info.unread === vm.app_flag.ON && vm.info.type !== vm.info_type.TODO) {
            // 既読処理
            vm.read(vm.info.id)
          }

          // 取得したお知らせに人物IDが必要な場合
          if (vm.isNeedSidPerson(vm.info.type, vm.info.function)) {
            vm.getSidPerson(vm.info.sid_data)
          }

          vm.isLoading = false
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  },
  methods: {
    getBoxClassName (type) {
      switch (type) {
        case 'E':
          return 'box-danger'
        case 'I':
          return 'box-success'
        case 'T':
          return 'box-warning'
        default:
          return 'box-default'
      }
    },
    isNeedSidPerson (type, func) {
      // お知らせ種別 = TODO かつ 機能番号 = 同一人物判定 の場合
      // 同一人物判定
      if (type === this.info_type.TODO && func === this.info_function.DUPLICATED) {
        return false
      }
      // 機能番号 = 同一人物判定 の場合
      // 名刺詳細（名刺人物ID）
      else if (func === this.info_function.DUPLICATED) {
        return false
      }
      // 修正サービス読み取りエラーの場合
      // BT0050360 戻るパスをお知らせ一覧にする
      else if (func === this.info_function.DAIKO) {
        return true
      }
      // 最新名刺入れ替えの場合
      else if (func === this.info_function.NEWBCCHANGED) {
        return false
      }
      // その他
      // 名刺詳細（名刺ID）
      else {
        return true
      }
    },
    // 既読処理
    read (id) {
      const vm = this

      InfoRepository.put(id)
        .then(function (response) {
          vm.$store.dispatch('reloadHeaderInfo')
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    delData () {
      const vm = this
      // API実行
      InfoRepository.delete(this.id)
        .then(function (response) {
          vm.$store.dispatch('reloadHeaderInfo')
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'information'})
          }
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    getSidPerson (sidBcard) {
      if (!sidBcard) {
        return
      }

      const vm = this
      BcardRepository.get(sidBcard, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.sidPerson = data.sid_person
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'お知らせの追加情報が取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/information/Detail.vue